import * as React from "react"

const SvgTextUnderline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 21.286a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h12a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm6-4q-2.525 0-3.925-1.575t-1.4-4.175V4.56q0-.525.388-.9a1.27 1.27 0 0 1 .912-.375q.525 0 .9.375c.375.375.375.55.375.9v7.125q0 1.4.7 2.275t2.05.875 2.05-.875.7-2.275V4.56q0-.525.387-.9a1.27 1.27 0 0 1 .913-.375q.525 0 .9.375c.375.375.375.55.375.9v6.975q0 2.6-1.4 4.175T12 17.285Z" />
  </svg>
)
export default SvgTextUnderline
